export default {"src":"/_next/static/media/alarm-clock.30c11b0a.png","height":512,"width":512,"blurWidth":0,"blurHeight":0};